"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetDetailDocument = void 0;
var AssetDetailDocument_1 = require("./AssetDetailDocument");
Object.defineProperty(exports, "AssetDetailDocument", { enumerable: true, get: function () { return AssetDetailDocument_1.AssetDetailDocument; } });
